module.exports = __webpack_public_path__ + "static/servicios-coles-bda839f12a62ac993e6ef8d84827c5fd.png";